var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrinHeartsDuotone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fad",
    "data-icon": "grin-hearts",
    className: "svg-inline--fa fa-grin-hearts fa-w-16",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fa-group"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fa-secondary",
    fill: "#fff",
    d: "M248,8C111,8,0,119,0,256S111,504,248,504,496,393,496,256,385,8,248,8ZM90.4,183.6c6.7-17.6,26.7-26.7,44.9-21.9l7.1,1.9,2-7.1c5-18.1,22.8-30.9,41.5-27.9a35.38,35.38,0,0,1,29.71,40.26h0a35.93,35.93,0,0,1-.91,4.24L195.3,243a8.59,8.59,0,0,1-10.5,6l-70.2-18.2a35.49,35.49,0,0,1-25.47-43.25h0A34.27,34.27,0,0,1,90.4,183.6ZM391.8,338.7c-9.3,55-83.2,93.3-143.8,93.3s-134.5-38.3-143.8-93.3a16,16,0,0,1,20.7-17.9C155.1,330.5,200,336,248,336s92.9-5.5,123.1-15.2a16.08,16.08,0,0,1,20.7,17.9Zm-10.4-108-70.2,18.2a8.68,8.68,0,0,1-10.5-6L281.3,173a35.38,35.38,0,0,1,24.54-43.59h0a35.93,35.93,0,0,1,4.24-.91c18.6-3,36.4,9.8,41.5,27.9l2,7.1,7.1-1.9c18.2-4.7,38.2,4.3,44.9,21.9a35.42,35.42,0,0,1-20.1,45.88,36.92,36.92,0,0,1-4.1,1.32Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "fa-primary",
    fill: "#eee",
    d: "M185.9,128.6c-18.7-3-36.5,9.8-41.5,27.9l-2,7.1-7.1-1.9c-18.2-4.8-38.2,4.3-44.9,21.9a35.5,35.5,0,0,0,20.25,45.93,36.32,36.32,0,0,0,3.95,1.27L184.8,249a8.59,8.59,0,0,0,10.5-6l19.4-69.9a35.38,35.38,0,0,0-24.54-43.59h0a35.93,35.93,0,0,0-4.24-.91Zm219.7,54.9c-6.7-17.6-26.7-26.6-44.9-21.9l-7.1,1.9-2-7.1c-5.1-18.1-22.9-30.9-41.5-27.9a35.38,35.38,0,0,0-29.71,40.26h0a35.93,35.93,0,0,0,.91,4.24l19.4,69.9a8.68,8.68,0,0,0,10.5,6l70.2-18.2a35.4,35.4,0,0,0,25.52-43.08v0a36.92,36.92,0,0,0-1.32-4.1Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrinHeartsDuotone);
export default __webpack_public_path__ + "static/media/grin-hearts-duotone.a956970106d4611c1c26a6b43997c17f.svg";
export { ForwardRef as ReactComponent };